<template>
  <el-dialog
      :close-on-click-modal="false"
      :title="ModalBaslik"
      :visible.sync="Durum"
      :before-close="Kapat"
      :v-loading="lo"
  >
    <el-form v-loading="lo" status-icon :model="Form" @submit.prevent.native="Gonder" :rules="FormHata"
             ref="Form">
      <el-row :gutter="24">
        <el-col :span="16">
          <el-form-item label="Ünvan" prop="Unvan">
            <el-input type="text" v-model="Form.Unvan" autocomplete="off"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="Grup" prop="Grup_id">
            <el-select v-model="Form.Grup_id" clearable filterable placeholder="Grup Seçiniz">
              <el-option
                  v-for="item in Gruplar"
                  :key="item.id"
                  :label="item.Adi"
                  :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Telefon" prop="Telefon">
            <el-input type="text" v-mask="'### ### ## ##'" v-model="Form.Telefon" autocomplete="off"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Email" prop="Email">
            <el-input type="email" v-model="Form.Email" autocomplete="off"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Vergi Dairesi" prop="vDaire">
            <el-input type="text" v-model="Form.vDaire" autocomplete="off"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Vergi No" prop="vNo">
            <el-input type="text" v-model="Form.vNo" autocomplete="off"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="Adres" prop="Adres">
            <el-input type="textarea" v-model="Form.Adres" autocomplete="off"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-divider content-position="left">Yetkili Bilgileri</el-divider>
      <el-row :gutter="24">
        <el-col :span="12">
          <el-form-item label="Ad Soyad" prop="Yetkili">
            <el-input type="text" v-model="Form.Yetkili" autocomplete="off"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Telefon" prop="YetkiliTel">
            <el-input type="text" v-mask="'### ### ## ##'" v-model="Form.YetkiliTel" autocomplete="off"></el-input>
          </el-form-item>
        </el-col>
      </el-row>


    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" type="danger" @click="Kapat">İptal</el-button>
      <el-button size="small" type="primary" :loading="lo" @click="Gonder">Kaydet</el-button>
    </div>
  </el-dialog>

</template>

<script>
export default {
  props: ['Bilgi', 'Durum'],
  data() {
    return {
      ModalBaslik: '',
      lo: false,
      Form: null,
      Gruplar: null,
      FormHata: {
        Unvan: [{required: true, message: "Ünvan Giriniz", trigger: 'blur'}]
      },
    }
  },
  methods: {
    Kapat() {
      this.$emit('Durum')
    },
    Gonder() {
      this.$refs['Form'].validate((valid) => {
        if (valid) {
          this.lo = true
          var Tur = this.Bilgi ? 'Put' : 'Post'
          this.$store.dispatch(Tur, {...this.Form, path: 'cari'})
              .then(response => {
                if (response.Durum == "OK") {
                  this.$emit('Durum')
                  this.$notify.success({
                    title: response.Mesaj,
                    customClass: 'success'
                  });
                  this.lo = false
                  if (Tur == 'Post') this.$router.push("/muhasebe/cari/" + response.Cari_id);
                } else {
                  this.$notify.error({
                    title: response.Mesaj,
                    customClass: 'error'
                  });
                  this.lo = false
                }
              })
        }
      })

    }
  },
  created() {
    if (this.Bilgi) {
      this.Form = this.Bilgi
      this.ModalBaslik = this.Bilgi.Unvan
    } else {
      this.Form = {
        Unvan: '',
        Telefon: '',
        Email: '',
        Yetkili: '',
        YetkiliTel: '',
        vDaire: '',
        vNo: '',
        Adres: '',
        Grup_id: null,
      }
      this.ModalBaslik = 'Cari Ekle'
    }
    this.$store.dispatch("Get", {path: 'grup/'})
        .then(response => {
          this.Gruplar = response.Liste
        })
  }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/pages/Muhasebe/Cari/Comp/CariModal.vue